module.exports = __webpack_public_path__ + "img/TreeClose.8386d227.svg";